<template>
  <form class="columns is-variable is-4">
    <div class="column is-9">
      <b-field>
        <b-input
          size="is-large is-rounded"
          icon="search"
          name="search_term"
          :placeholder="$t('placeholder')" type="search"
          v-model="term" />
      </b-field>
    </div>
    <div class="column is-3">
      <div class="control">
        <button
          type="submit"
          class="button is-danger is-fullwidth is-large is-rounded"
          @click.prevent="runSearch()"
          v-t="'button'" />
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'SearchForm',
  data () {
    return {
      term: ''
    }
  },
  mounted () {
    let query = this.$route.query
    if (typeof query.term !== 'undefined') {
      this.term = this.$route.query.term
    }
  },
  methods: {
    runSearch () {
      this.$router.push({ name: 'search', query: { term: this.term } })
    }
  }
}
</script>

<i18n>
{
  "en-US": {
    "placeholder": "Enter your question or problem",
    "button": "Search"
  },
  "pt-BR": {
    "placeholder": "Digite qual sua dúvida ou problema",
    "button": "Buscar"
  }
}
</i18n>
